import {Storable} from '../interfaces/storable';
import {RouteGpxDTO} from '../dto/route-gpx-dto';

export class RouteGpx extends Storable<RouteGpxDTO> {
  private readonly _id: number;
  private readonly _gpx: string;

  constructor(data: RouteGpxDTO) {
    super();
    this._id = data.id;
    this._gpx = data.gpx;
  }

  get id(): number {
    return this._id;
  }

  get gpx(): string {
    return this._gpx;
  }

  getDTO(): RouteGpxDTO {
    return {
      id: this._id,
      gpx: this._gpx,
    };
  }
}
